import { defaultCurrentUnifyComponent } from './state'

/**
 * Mutación que establece la cantidad de ítem por página.
 *
 * @param per_page - cantidad de ítem.
 * @param int state.tableConfig.items.per_page - Cantidad de registros por página.
 * @param int state.tableConfig.items.page - Página actual.
 * @return void
 */
export function setSizePagination(state, per_page) {
    state.tableConfig.items = {
        ...state.tableConfig.items,
        page: 1,
        per_page
    };
}

/**
 * Mutación que establece la página actual.
 *
 * @param state.tableConfig.items.current_page - nueva página.
 * @param int - nueva página.
 * @return void
 */
export function setPagePagination(state, page) {
    state.tableConfig.items.current_page = page;
}

/**
 * Mutación manipular/alterar el estado de la acción que se esta realizando.
 *
 * @param Object state
 * @param string nextState
 * @return void
 */
export function setAction(state, nextState) {
    state.action = nextState
}

/**
 * Mutación manipular/alterar restablecer al data del detalle actual.
 *
 * @param object state
 * @return void
 */
export function resetCurrentUnifyComponent(state) {
    state.currentUnifyComponent = defaultCurrentUnifyComponent();
}

/**
 * Mutación manipular/alterar alterar la data del detalle actual.
 *
 * @param object state
 * @param object nextState
 * @return void
 */
export function setCurrentUnifyComponent(state, nextState) {
    state.currentUnifyComponent = nextState;
}

/**
 * Mutación manipular/alterar listado de unificaciones.
 *
 * @param object state.tableConfig.items - unificaciones actuales
 * @param object nextState - unificaciones nuevas
 * @return void
 */
export function setUnifyComponents(state, nextState) {
    state.tableConfig.items = nextState;
}

/**
 * Mutación manipular/alterar listado de componentes para seleccionar el primario.
 *
 * @param object state.componentsToPrimaries - componentes actuales
 * @param object nextState - componentes nuevos
 * @return void
 */
export function setComponentsToPrimaries(state, nextState) {
    state.componentsToPrimaries = nextState;
}

